// @flow
import { type TabKey } from "@tvg/atomic-ui/_templates/PoolsNInfo/";

type SelectedPoolsNInfoTabAction = {
  type: "POOLS_N_INFO_TAB",
  payload: TabKey
};

export type TogglePoolsNInfoModalAction = {
  type: "TOGGLE_POOLS_N_INFO_MODAL",
  payload: boolean
};

export type Actions = SelectedPoolsNInfoTabAction | TogglePoolsNInfoModalAction;

export const setSelectedPoolsNInfoTab = (
  value: TabKey
): SelectedPoolsNInfoTabAction => ({
  type: "POOLS_N_INFO_TAB",
  payload: value
});

export const togglePoolsNInfoModal = (
  value: boolean
): TogglePoolsNInfoModalAction => ({
  type: "TOGGLE_POOLS_N_INFO_MODAL",
  payload: value
});
